import { apiSlice } from "../apiSlice/apiSlice";
import { userLoggedIn } from "./authSlice";

export const authApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getAllUser: builder.query({
            query: () => '/users?role=student'
        }),
        getAdmins: builder.query({
            query: () => '/users?role=admin'
        }),

        register: builder.mutation({
            query: (info) => {
                const { name, email, password } = info || {}
                const data = {
                    name,
                    email,
                    password,
                    role: 'student'
                }

                return ({
                    url: "/register",
                    method: "POST",
                    body: data,
                })
            },
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const result = await queryFulfilled;

                    localStorage.setItem(
                        "auth",
                        JSON.stringify({
                            accessToken: result.data.accessToken,
                            user: result.data.user,
                        })
                    );

                    dispatch(
                        userLoggedIn({
                            accessToken: result.data.accessToken,
                            user: result.data.user,
                        })
                    );
                    dispatch(apiSlice.util.updateQueryData(
                        'getAllUser',
                        undefined,
                        (draft) => {
                            draft.push(result.data?.user)
                        }
                    ))
                } catch (err) {
                    // do nothing
                }
            },
        }),
        login: builder.mutation({
            query: (data) => ({
                url: "/login",
                method: "POST",
                body: data,
            }),

            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const result = await queryFulfilled;

                    if (result?.data?.user?.role === 'student') {
                        localStorage.setItem(
                            "auth",
                            JSON.stringify({
                                accessToken: result.data.accessToken,
                                user: result.data.user,
                            })
                        );

                        dispatch(
                            userLoggedIn({
                                accessToken: result.data.accessToken,
                                user: result.data.user,
                            })
                        );
                    }
                } catch (err) {
                    // do nothing
                }
            },
        }),
        adminLogin: builder.mutation({
            query: (data) => ({
                url: "/login",
                method: "POST",
                body: data,
            }),

            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const result = await queryFulfilled;
                    const { data } = result || {}
                    const { user } = data || {}
                    if (user.role === 'admin') {
                        localStorage.setItem(
                            "auth",
                            JSON.stringify({
                                accessToken: result.data.accessToken,
                                user: result.data.user,
                            })
                        );

                        dispatch(
                            userLoggedIn({
                                accessToken: result.data.accessToken,
                                user: result.data.user,
                            })
                        );
                    } else {
                        throw new Error('Something went wrong!');
                    }
                } catch (err) {
                    // do nothing 
                }
            },
        }),
        updateAdminPassword: builder.mutation({
            query: (data) => ({
                url: `/users/${data.id}`,
                method: "PATCH",
                body: data,
            }),
            async onQueryStarted(arg, { queryFulfilled, dispatch }) {
                try {
                    const result = await queryFulfilled;
                    const { data } = result || {}
                    const { user } = data || {}

                    if (user.role === 'admin') {
                        localStorage.setItem(
                            "auth",
                            JSON.stringify({
                                accessToken: result.data.accessToken,
                                user: result.data.user,
                            })
                        );

                        dispatch(
                            userLoggedIn({
                                accessToken: result.data.accessToken,
                                user: result.data.user,
                            })
                        );
                    }
                } catch (err) {
                    // do nothing 
                }
            },
        })
    }),
});

export const { useLoginMutation, useRegisterMutation, useGetAllUserQuery, useAdminLoginMutation, useGetAdminsQuery, useUpdateAdminPasswordMutation } = authApi;